<template>
  <a-layout class="my-application-box">
    <a-card class="create-application" :bordered=false :class="fromLocation==='msg'?'msg-create-application':''">
      <div slot="title" v-if="pageLayout.pageTitle">
        <a-icon v-if="fromLocation==='app'" style="cursor:pointer;" type="left-circle" @click="back" />
        <div>{{pageLayout.pageTitle}}</div>
        <span class="page-status " :class="{'page-status-yellow':params.status==='审批中','page-status-green':params.status==='审批通过'||params.status==='付款成功','page-status-red':params.status==='审批拒绝'||params.status==='付款失败','page-status-gray':params.status==='已撤回'}">{{params.status}}</span>
      </div>
      <div v-for="(layout,index) in pageLayout.contents" :key="index" v-if="loadedLayout && loadedInfo">
        <common-form :ref="'commonForm'" :layout="layout" v-if="layout.type==='commonForm'" :params="layout.field && params[layout.field]?params[layout.field]:{}" :can-edit="canEdit" :need-id="true" @changed-fields="onFieldChange"></common-form>
        <multi-form :ref="'multiForm'" :layout="layout" v-if="layout.type==='multiForm'" :params="layout.field && params[layout.field]?params[layout.field]:[]" :can-edit="canEdit" :need-id="true" @changed-fields="onFieldChange"></multi-form>
        <summation :layout="layout" v-if="layout.type==='summation'" :params="params[layout.field]?params[layout.field]:{}" :all-params="params" :from-detail="false" @changed-fields="setSummationInfo"></summation>
        <upload v-if="layout.type==='upload'" :layout="layout" :params="params[layout.field]?params[layout.field]:[]" :can-edit="canEdit" @changed-fields="onFieldChange"></upload>
        <a-divider/>
      </div>
      <approval-flow :params="approvalFlowInfo" :init-text="'审批流数据加载中...'" v-if="loadedLayout && loadedInfo"></approval-flow>
      <a-row style="margin:30px 0 24px;" v-if="loadedInfo && loadedLayout">
        <a-col :xs="24" :sm="4"></a-col>
        <a-col :xs="24" :sm="10">
          <a-button type="primary" style="width:120px;margin-right: 18px" :disabled="!canSubmit" @click="submit">提交</a-button>
          <a-button @click="visibleComment = true" style="width:120px;">评论</a-button>
        </a-col>
      </a-row>
      <div style="text-align:center" v-else>
        <a-spin tip="数据加载中..."></a-spin>
      </div>
      <comment-and-copy :visible="visibleComment" @cancel="visibleComment = false" @reload="reload"></comment-and-copy>
    </a-card>
  </a-layout>
</template>

<script>
import UUID from "uuidjs";
import SvgIcBackbtn from "../../assets/svg/ic-left-circle-o.svg";
import SvgIcFile from "../../assets/svg/ic-file-o.svg";
import SvgIcEdit from "../../assets/svg/ic-edit-o.svg";
import SvgIcCopy from "../../assets/svg/ic-copy-o.svg";
import SvgIcEnter from "../../assets/svg/ic-enter.svg";
import CommonForm from "../../components/CommonForm.vue";
import MultiForm from "../../components/MultiForm.vue";
import Summation from "../../components/Summation.vue";
import ApprovalFlow from "../../components/ApprovalFlow.vue";
import FormModal from "../../components/FormModal.vue";
import Upload from "../../components/Upload.vue";
import { setTimeout } from "timers";
import LayoutConfig from "../../utils/LayoutConfig.js";
import { layoutConfig } from "../../utils/mockData.js";
import {
  getPurchaseLayout,
  getPurchaseDetailInfo,
  submitPurchase,
  getPurchaseFlow
} from "../../services/CommonService.js";

export default {
  components: {
    SvgIcBackbtn,
    SvgIcFile,
    SvgIcEdit,
    SvgIcCopy,
    SvgIcEnter,
    CommonForm,
    MultiForm,
    Summation,
    ApprovalFlow,
    FormModal,
    Upload
  },
  data() {
    return {
      canEdit: true,
      retreatModalVisible: false,
      breadcrumb: [
        {
          label: "我的申请",
          path: ""
        }
      ],
      cardHeight: 0,
      applicationTitle: "发起采购申请",
      params: {
        init: true
      },
      requestParams: {},
      loadedLayout: false,
      loadedInfo: false,
      pageLayout: {},
      approvalFlowInfo: [],
      fromLocation: undefined,
      canSubmit: true,
      visibleComment: false
    };
  },

  created() {
    this.fromLocation =
      window.location.href.indexOf("fromLocation=msg") === -1 ? "app" : "msg";
    this.id = this.$route.query.id;
    Promise.all([this.fetchDetailInfo()]).then(() => {
      this.fetchLayout();
    });
  },
  mounted() {},

  computed: {
    approvalFlowDependParams() {
      const params = _.cloneDeep(this.requestParams);
      if (this.requestParams.basicInfo && this.requestParams.total_pay) {
        return {
          undertake_group_id: this.requestParams.basicInfo.undertake_group_id,
          type: this.requestParams.basicInfo.type,
          total_pay: this.requestParams.total_pay
        };
      }
    }
  },

  methods: {
    fetchLayout() {
      this.loadedLayout = false;
      getPurchaseLayout({ type: "create" }).then(res => {
        if (res.status === "success") {
          this.pageLayout = res.data;
          this.loadedLayout = true;
        } else {
          this.$Message.error(res.message);
          this.loadedLayout = true;
        }
      });
    },
    fetchDetailInfo() {
      this.loadedInfo = false;
      return getPurchaseDetailInfo({
        id: this.$route.query.id,
        type: "create"
      }).then(res => {
        if (res.status === "success") {
          this.params = Object.assign({}, this.params, res.data);
          this.loadedInfo = true;
        } else {
          this.$Message.error(res.message);
          this.loadedInfo = true;
        }
      });
    },
    fetchApprovalFlow() {
      this.approvalFlowInfo = [];
      this.cancelQuest();
      getPurchaseFlow(this.requestParams, this).then(res => {
        if (res.status === "success") {
          if (res.data && _.isArray(res.data)) {
            res.data.forEach((item, index) => {
              this.$set(this.approvalFlowInfo, index, item);
            });
          }
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    onFieldChange(e) {
      this.params = Object.assign({}, this.params, e);
      LayoutConfig.setAllParams(this.params);
      this.requestParams = _.cloneDeep(this.params);
      console.log(this.requestParams);
    },
    setSummationInfo(e) {
      this.summationInfo = e;
      this.requestParams = _.cloneDeep(this.params);
      this.requestParams = Object.assign(
        this.requestParams,
        this.summationInfo
      );
    },
    back() {
      this.$router.replace({
        name: "myApplicationList"
      });
    },
    cancelQuest() {
      if (typeof this.cancelSource === "function") {
        this.cancelSource("终止请求"); //取消请求
      }
    },
    submit() {
      let validateResult = true;
      Object.keys(this.$refs).forEach(key => {
        if (key.indexOf("commonForm") || key.indexOf("multiForm")) {
          this.$refs[key].forEach(item => {
            if (!item.validateFields()) {
              validateResult = false;
            }
          });
        }
      });
      if (validateResult) {
        this.canSubmit = false;
        submitPurchase(this.requestParams).then(res => {
          if (res.status === "success") {
            this.$Message.success("创建申请成功");
            this.$router.replace({
              name: "myApplicationList",
              query: {
                apply_type: 7
              }
            });
          } else {
            this.$Message.error(res.message);
          }
          this.canSubmit = true;
        });
      }
    },

    reload() {
      this.visibleComment = false;
      this.fetchApprovalFlow();
    }
  },
  watch: {
    approvalFlowDependParams: {
      handler(val) {
        if (
          val &&
          val.undertake_group_id &&
          val.type &&
          val.total_pay &&
          val.total_pay !== "0.00"
        ) {
          this.copyVal = _.cloneDeep(val);
          this.fetchApprovalFlow();
        }
      },
      deep: true
    }
  }
};
</script>

<style lang="less">
.my-application-box {
  padding: 16px;
}
</style>
